<template>
  <div class="register">
    <RegisterHeader> </RegisterHeader>
    <div class="register-main">
      <!-- 头部过程 -->
      <div class="flow">
        <div class="flowcontent">
          <div class="schedule">
            <div>
              <i class="iconfont icon-a-12"></i>
            </div>
            <div>验证手机</div>
          </div>
          <img
            v-show="istwo"
            class="img1"
            src="@/assets/images/carImg/arrows/group -1.png"
            alt=""
          />
          <img
            v-show="!istwo"
            class="img1"
            src="@/assets/images/carImg/arrows/group 92.png"
            alt=""
          />
          <div class="schedule">
            <div>
              <i
                class="iconfont icon-a-18"
                style="color: #dedede"
                v-show="istwo"
              ></i>
              <i
                class="iconfont icon-a-18"
                v-show="!istwo"
                style="color: #377cf1"
              ></i>
            </div>
            <div>填写资料</div>
          </div>
          <img
            v-show="isthree"
            class="img1"
            src="@/assets/images/carImg/arrows/group -1.png"
            alt=""
          />
          <img
            v-show="!isthree"
            class="img1"
            src="@/assets/images/carImg/arrows/group 92.png"
            alt=""
          />
          <div class="schedule">
            <div>
              <i
                class="iconfont icon-a-181"
                style="color: #dedede"
                v-show="isthree"
              ></i>
              <i
                class="iconfont icon-a-181"
                style="color: #377cf1"
                v-show="!isthree"
              ></i>
            </div>
            <div>注册完成</div>
          </div>
        </div>
      </div>
      <!-- 中间 -->
      <!-- 第一步 -->
      <div class="w" v-show="isphone">
        <Form
          :model="formLeft"
          label-position="left"
          :label-width="110"
          :rules="ruleform"
          ref="formLeft"
        >
          <FormItem label="手机号：" prop="phone">
            <Input
              v-model="formLeft.phone"
              placeholder="请输入您的手机号"
              @on-blur="onblur('formLeft')"
            ></Input>
          </FormItem>
          <FormItem label="验证码：" prop="code" class="input-password">
            <Input
              v-model="formLeft.code"
              placeholder="请输入手机验证码"
              style="width: 65%; margin-right: 1%"
              @on-blur="onblur('formLeft')"
            >
            </Input>
            <Button
              style="width: 34%"
              class="span-btn"
              type="primary"
              @click="getCode('formLeft')"
              :disabled="disabled"
              >{{ btnText }}</Button
            >
          </FormItem>
          <!-- <FormItem label="密码：" prop="password">
            <Input
              v-model="formLeft.password"
              placeholder="请输入密码"
              type="password"
              @on-blur="onblur('formLeft')"
            ></Input>
            <span style="color: #c2c2c2; font-size: 12px"
              >至少输入8位，支持字母、数字、标点符号。字母区分大小写</span
            >
          </FormItem>
          <FormItem label="确认密码：" prop="passwords">
            <Input
              v-model="formLeft.passwords"
              placeholder="请再次输入密码"
              type="password"
              @on-blur="onblur('formLeft')"
            ></Input>
          </FormItem> -->
        </Form>
        <div
          style="text-align: center; margin: 30px 0 36px 110px; padding: 5px, 0"
        >
          <Checkbox
            v-model="agreed"
            style="color: #555555"
            @on-change="checkChange('formLeft')"
            >我已阅读并同意</Checkbox
          ><span
            style="color: #f62b4e; cursor: pointer"
            @click="agreeModal = true"
            >《极联用户注册协议》</span
          >
        </div>
        <div style="margin-left: 112px" class="loginbtn">
          <Button
            type="primary"
            long
            :disabled="isShow"
            @click="saveNext('formLeft')"
            :loading="loading"
            >下一步</Button
          >
          <!-- <div style="height: 30px"></div>
        <Button
          :disabled="!isShow"
          type="error"
          long
          @click="savePhone('formLeft')"
          :loading="loading"
          >保存</Button
        > -->
        </div>
      </div>
      <!-- 第二步 -->
      <div class="w-t" v-show="isInformation">
        <Form
          label-position="left"
          :label-width="130"
          :model="formList"
          :rules="ruleforms"
          ref="formList"
        >
          <div class="h3-fa">
            <div class="h3">
              <i></i>
              <h3>基本信息</h3>
            </div>
          </div>
          <div class="w-border">
            <FormItem label="企业名称：" prop="tenantName" class="h3-fa">
              <Input
                @on-blur="blurInput"
                v-model="formList.tenantName"
                placeholder="企业名称需要与营业执照名称一致，否则审核不通过"
              >
              </Input>
            </FormItem>
            <FormItem label="所在地区：" prop="provinceId">
              <Select
                v-model="formList.provinceId"
                style="width: 128px"
                @on-change="provinceChange"
                :label-in-value="true"
              >
                <Option
                  v-for="item in provinceList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
              <Select
                v-model="formList.cityId"
                style="width: 128px; margin: 0 7px"
                @on-change="cityChange"
                :label-in-value="true"
              >
                <Option
                  v-for="item in cityList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
              <Select
                v-model="formList.areaId"
                style="width: 128px"
                @on-change="areaChange"
                :label-in-value="true"
              >
                <Option
                  v-for="item in areaList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="详细地址：" prop="addr">
              <Input
                @on-blur="btnIshows"
                type="textarea"
                v-model="formList.addr"
                class="box2"
                placeholder="请输入详细经营地址"
              >
              </Input>
            </FormItem>
            <FormItem label="联系人：" prop="applicant">
              <Input
                @on-blur="btnIshows"
                v-model="formList.applicant"
                placeholder="请输入全名，方便客服称呼"
              >
              </Input>
            </FormItem>
            <FormItem label="联系人手机号：" prop="phone">
              <Input v-model="formList.phone" disabled> </Input>
            </FormItem>
            <!-- <FormItem label="邀请码：" prop="inviterCode">
              <Input
                v-model="formList.inviterCode"
                placeholder="请输入邀请码"
              ></Input>
            </FormItem> -->
          </div>
          <div class="w-border center">
            <div class="h3-fa">
              <div class="h3" style="top: -20px; left: -113px">
                <i></i>
                <h3>认证信息</h3>
              </div>
            </div>
            <FormItem class="form-img">
              <Row type="flex" align="top">
                <Col v-show="show1" span="12">
                  <upload
                    :options="options1"
                    class="uploads"
                    @getOssRes="getidCartFrontImg"
                  ></upload>
                </Col>
                <Col v-show="!show1" class="img-show">
                  <img :src="formList.idCardFrontImg" alt="" />
                  <Icon
                    type="md-close-circle"
                    size="23"
                    color="#e90d0d"
                    @click="delimages(0)"
                  />
                </Col>
                <Col span="12">
                  图例
                  <img src="../../../assets/images/home/1.png" alt="" />
                </Col>
              </Row>
              <Row type="flex">
                <Col v-show="show2" span="12">
                  <upload
                    :options="options2"
                    @getOssRes="getidCardBackImg"
                  ></upload>
                </Col>
                <Col v-show="!show2" class="img-show">
                  <img :src="formList.idCardBackImg" alt="" />
                  <Icon
                    type="md-close-circle"
                    size="23"
                    color="#e90d0d"
                    @click="delimages(1)"
                  />
                </Col>
                <Col span="12">
                  图例
                  <img src="../../../assets/images/home/2.png" alt="" />
                </Col>
              </Row>
              <Row type="flex">
                <Col v-show="show3" span="12">
                  <upload
                    :options="options3"
                    @getOssRes="getlicenseImg"
                  ></upload>
                </Col>
                <Col v-show="!show3" class="img-show">
                  <img :src="formList.licenseImg" alt="" />
                  <Icon
                    type="md-close-circle"
                    size="23"
                    color="#e90d0d"
                    @click="delimages(2)"
                  />
                </Col>
                <Col span="12">
                  图例
                  <img src="../../../assets/images/home/3.png" alt="" />
                </Col>
              </Row>
              <Row type="flex">
                <Col v-show="show4" span="12">
                  <upload
                    :options="options4"
                    @getOssRes="getfacadeImg"
                  ></upload>
                </Col>
                <Col v-show="!show4" class="img-show">
                  <img :src="formList.facadeImg" alt="" />

                  <Icon
                    type="md-close-circle"
                    size="23"
                    color="#e90d0d"
                    @click="delimages(3)"
                  />
                </Col>
                <Col span="12">
                  图例
                  <img src="../../../assets/images/home/4.png" alt="" />
                </Col>
              </Row>
            </FormItem>
          </div>
        </Form>
        <div class="loginbtn">
          <Button
            style="
              height: 40px;
              width: 400px;
              font-size: 18px;
              font-weight: 500;
            "
            type="primary"
            long
            :disabled="isShows"
            @click="saveTwo('formList')"
            :loading="loading1"
            >下一步</Button
          >
        </div>
      </div>
      <div class="w-b" v-show="isFinish">
        <div class="spans">
          <span class="iconfont icon-weibiaoti-2"></span
          ><i>申请正在处理中...</i>
        </div>
        <p>
          平台已收到
          <i style="color: #f62b4e">{{ formList.tenantName }}</i>
          提交的入驻平台注册资料，客服会在5个工作日内与您联系，进行信息核实，
          请注意接听电话。
        </p>
      </div>
    </div>

    <!-- 用户注册协议弹框 -->
    <Modal
      style="text-align: center"
      v-model="agreeModal"
      title="《极联用户注册协议》"
      width="700"
      draggable
      :mask-closable="false"
    >
      <Scroll height="500">
        <RegisterTcp></RegisterTcp>
      </Scroll>
      <div slot="footer" class="foote" style="text-align: center">
        <Button type="primary" @click="btnOK">我已阅读并同意</Button>
      </div>
    </Modal>
    <!-- 尾部 -->
    <LoginFooter></LoginFooter>
  </div>
</template>

<script>
import upload from '../uploadify/upload.vue'
import LoginFooter from './components/login-footer.vue'
import RegisterHeader from './components/register-header.vue'
import RegisterTcp from './components/register-tcp.vue'
import {
  getCodeSMS,
  getResAreaByParent,
  getPhone,
  getnameable,
  getTenant
} from '@/api/user.js'
export default {
  components: { LoginFooter, RegisterHeader, RegisterTcp, upload },
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请您重新输入您的密码'))
      } else if (value !== this.formLeft.password) {
        callback(new Error('两次密码请输入一致'))
      } else {
        callback()
      }
    }
    const validateinviterCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('邀请码错误'))
      } else if (value !== this.formList.phone) {
        callback(new Error('邀请码错误'))
      } else {
        callback()
      }
    }
    return {
      show1: true,
      show2: true,
      show3: true,
      show4: true,
      options1: {
        regiter1: true,
        size: 5,
        fileType: [
          'png',
          'jpg',
          'jpeg',
          'bmp',
          'gif',
          'webp',
          'psd',
          'svg',
          'tiff'
        ]
      },
      options2: {
        regiter2: true,
        size: 5,
        fileType: [
          'png',
          'jpg',
          'jpeg',
          'bmp',
          'gif',
          'webp',
          'psd',
          'svg',
          'tiff'
        ]
      },
      options3: {
        regiter3: true,
        size: 5,
        fileType: [
          'png',
          'jpg',
          'jpeg',
          'bmp',
          'gif',
          'webp',
          'psd',
          'svg',
          'tiff'
        ]
      },
      options4: {
        regiter4: true,
        size: 5,
        fileType: [
          'png',
          'jpg',
          'jpeg',
          'bmp',
          'gif',
          'webp',
          'psd',
          'svg',
          'tiff'
        ]
      },
      // 第一步
      formLeft: {
        phone: '',
        code: '',
        password: '',
        passwords: '',
        deviceId: ''
      },
      // 第二步
      formList: {
        tenantName: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        addr: '',
        applicant: '',
        phone: '',
        inviterCode: '',
        idCardFrontImg: '', // 正面
        idCardBackImg: '', // 反面
        licenseImg: '',
        facadeImg: '',
        platformCode: 'JP-WSS',
        accountId: ''
      },
      provinceList: [], // 省份数据
      cityList: [], // 城市数据
      areaList: [], // 区县数据
      totalCount: 0,
      disabled: false, // 控制按钮是否可以点击（false:可以点击，
      agreed: false, // 同意协议复选
      agreeModal: false, // 协议弹框
      isShows: true,
      isShow: true, // 下一步
      istwo: true,
      isthree: true, //资料
      isphone: true, // 手机页面
      isInformation: false, // 资料页面
      isFinish: false, // 完成页面
      loading: false,
      loading1: false,
      // 验证
      ruleform: {
        phone: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '登录密码不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            min: 8,
            message: '长度必须8位及以上',
            trigger: 'blur'
          }
        ],
        passwords: [
          {
            required: true,
            validator: validatePassCheck,
            trigger: 'blur'
          }
        ]
      },
      // 验证
      ruleforms: {
        tenantName: [
          {
            required: true,
            message: '企业名称不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            min: 2,
            max: 100,
            message: '最少输入两个字，最多不能超过100个字',
            trigger: 'blur'
          }
        ],
        provinceId: [
          {
            required: true,
            message: '所在地区不能为空',
            trigger: 'blur'
          }
          // {
          //   type: 'string',
          //   min: 2,
          //   max: 100,
          //   message: '最少输入两个字',
          //   trigger: 'blur'
          // }
        ],
        addr: [
          {
            required: true,
            message: '详细地址不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            min: 2,
            max: 100,
            message: '最少输入两个字，最多100个字',
            trigger: 'blur'
          }
        ],
        applicant: [
          {
            required: true,
            message: '联系人不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            min: 2,
            max: 100,
            message: '最少输入两个字，最多不能超过100个字',
            trigger: 'blur'
          }
        ],
        inviterCode: [
          {
            required: false,
            message: '邀请码错误',
            trigger: 'blur'
          },
          {
            pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
            message: '邀请码错误',
            trigger: 'blur'
          }
          // {
          //   type: 'Numbers',
          //   validator: validateinviterCode,
          //   trigger: 'change'
          // }
        ]
      }
    }
  },
  created() {},
  methods: {
    // 获取短信验证码
    getCode(formLeft) {
      this.$refs[formLeft].validateField('phone', async (mobileError) => {
        if (mobileError) {
          this.$Message.warning('必须是手机号')
        } else {
          this.disabled = true
          // 按钮60秒倒计时
          this.totalCount = 60
          const res = await getCodeSMS({
            phone: this.formLeft.phone,
            platformCode: 'JP-WSS'
          })
          if (res.code == 0) {
            console.log(res)
            this.formLeft.deviceId = res.data
          }
          console.log(res)
          this.interval = setInterval(() => {
            this.totalCount--
            if (this.totalCount === 0) {
              clearInterval(this.interval)
              this.disabled = false
            }
          }, 1000)
        }
      })
    },
    // 我已清楚协议
    btnOK() {
      this.agreeModal = false
      this.agreed = true
    },
    onblur(formLeft) {
      this.$refs[formLeft].validate(async (valid) => {
        if (valid) {
          if (this.agreed === true) {
            this.isShow = false
          }
        }
      })
    },
    checkChange(formLeft) {
      console.log(this.agreed)
      // if (this.agreed == false) {
      //   console.log(this.agreed);
      //   // this.$Message.warning('请阅读《极联用户注册协议》')
      // } else {
      this.$refs[formLeft].validate(async (valid) => {
        if (valid) {
          console.log(this.agreed)
          if (this.agreed == false) {
            this.$Message.warning('请阅读《极联用户注册协议》')
          } else {
            this.isShow = false
          }
        }
      })
      console.log(this.agreed)
      // }
      // console.log(this.agreed);
    },
    // 保存手机
    // savePhone(formLeft) {
    //   if (this.agreed == false) {
    //     this.$Message.warning('请阅读《极联用户注册协议》')
    //   } else {
    //     this.$refs[formLeft].validate(async (valid) => {
    //       if (valid) {
    //         this.loading = true
    //         const res = await getPhone({
    //           platformCode: 'JP-WSS',
    //           phone: this.formLeft.phone,
    //           code: this.formLeft.code,
    //           deviceId: this.formLeft.deviceId,
    //           password: this.formLeft.password,
    //           passwords: this.formLeft.passwords
    //         })
    //         console.log(res)
    //         if (res.status) {
    //           this.formList.accountId = res.data.userid
    //           this.isShow = false
    //         }
    //       }
    //       this.loading = false
    //     })
    //   }
    // },
    // 手机下一步
    async saveNext(formLeft) {
      if (this.agreed == false) {
        this.$Message.warning('请阅读《极联用户注册协议》')
      } else {
        this.$refs[formLeft].validate(async (valid) => {
          if (valid) {
            this.loading = true
            const res = await getPhone({
              platformCode: 'JP-WSS',
              phone: this.formLeft.phone,
              code: this.formLeft.code,
              deviceId: this.formLeft.deviceId,
              password: this.formLeft.password,
              passwords: this.formLeft.passwords
            })
            console.log(res)
            if (res.status) {
              this.formList.accountId = res.data.userid
              this.isShow = false
              this.isphone = false
              this.istwo = false
              const province = await getResAreaByParent({ parentId: 0 })
              this.provinceList = province.data
              this.isInformation = true
              this.formList.phone = this.formLeft.phone
            }
          }
          this.loading = false
        })
      }
    },
    // 企业全称失去焦点发请求
    async blurInput() {
      const res = await getnameable({ name: this.formList.tenantName })
      console.log(res)
      if (res.status) {
      }
    },
    // 省改变
    async provinceChange(type) {
      if (type) {
        this.formList.provinceId = type.value
        // this.formList.provinceName = type.label
        const res = await getResAreaByParent({ parentId: type.value })
        this.cityList = []
        this.areaList = []
        this.cityList = res.data
        this.formList.areaId = ''
      }
    },
    // 市改变
    async cityChange(type) {
      if (type) {
        this.formList.cityId = type.value
        // this.formList.cityName = type.label
        const res = await getResAreaByParent({ parentId: type.value })
        this.areaList = []
        this.areaList = res.data
      }
    },
    async areaChange(type) {
      if (type) {
        this.formList.areaId = type.value
        // this.formList.areaName = type.label
        this.formList.areaId = type.value || ''
      }
    },
    // 正
    getidCartFrontImg(data) {
      if (data.res.statusCode == 200) {
        this.show1 = false
        this.formList.idCardFrontImg = data.url
        this.$Message.success('上传成功')
        this.$refs.formList.validate(async (valid) => {
          if (valid) {
            this.isShows = false
          } else {
            // this.$Message.error('验证不通过')
            this.isShows = true
          }
        })
      }
      console.log(data)
    },
    // 反
    getidCardBackImg(data) {
      if (data.res.statusCode == 200) {
        this.show2 = false
        this.formList.idCardBackImg = data.url
        this.$Message.success('上传成功')
        // this.$refs.formList.validate(async (valid) => {
        //   if (valid) {
        //     this.isShows = false
        //   } else {
        //     // this.$Message.error('验证不通过')
        //     this.isShows = true
        //   }
        // })
      }
    },
    getlicenseImg(data) {
      if (data.res.statusCode == 200) {
        this.show3 = false
        this.formList.licenseImg = data.url
        this.$Message.success('上传成功')
        this.$refs.formList.validate(async (valid) => {
          if (valid) {
            this.isShows = false
          } else {
            // this.$Message.error('验证不通过')
            this.isShows = true
          }
        })
      }
    },
    getfacadeImg(data) {
      if (data.res.statusCode == 200) {
        this.show4 = false
        this.formList.facadeImg = data.url
        this.$Message.success('上传成功')
        // this.$refs.formList.validate(async (valid) => {
        //   if (valid) {
        //     this.isShows = false
        //   } else {
        //     this.$Message.error('验证不通过')
        //     this.isShows = true
        //   }
        // })
      }
    },
    btnIshows() {
      this.$refs.formList.validate(async (valid) => {
        if (valid) {
          this.isShows = false
        } else {
          // this.$Message.error('验证不通过')
          this.isShows = true
        }
      })
    },
    // 删除图片
    delimages(val) {
      if (val == 0) {
        this.formList.idCardFrontImg = ''
        this.show1 = true
      } else if (val == 1) {
        this.formList.idCardBackImg = ''
        this.show2 = true
      } else if (val == 2) {
        this.formList.licenseImg = ''
        this.show3 = true
      } else {
        this.formList.facadeImg = ''
        this.show4 = true
      }
    },
    saveTwo(formList) {
      this.$refs[formList].validate(async (valid) => {
        if (valid) {
          this.loading1 = true
          const res = await getTenant({
            accountId: this.formList.accountId,
            addr: this.formList.addr,
            applicant: this.formList.applicant,
            areaId: this.formList.areaId,
            cityId: this.formList.cityId,
            facadeImg: encodeURIComponent(this.formList.facadeImg),
            idCardBackImg: encodeURIComponent(this.formList.idCardBackImg),
            idCardFrontImg: encodeURIComponent(this.formList.idCardFrontImg),
            licenseImg: encodeURIComponent(this.formList.licenseImg),
            inviterCode: this.formList.inviterCode,
            phone: this.formList.phone,
            platformCode: this.formList.platformCode,
            provinceId: this.formList.provinceId,
            provinceName: this.formList.provinceName,
            tenantName: this.formList.tenantName
          })
          console.log(res)
          if (res.status) {
            this.isInformation = false
            this.isFinish = true
            this.isthree = false
          }
        }
      })
      this.loading1 = false
    }
  },
  computed: {
    btnText() {
      return this.totalCount !== 0
        ? `${this.totalCount}秒再次获取`
        : '获取验证码'
    }
  },
  watch: {}
}
</script>
<style lang='less' scoped>
@import './register.less';
/deep/ .ivu-modal-header {
  background-color: #f0f0f0;
  .ivu-modal-header-inner {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>